import { boot } from 'quasar/wrappers';

export default boot(({ Vue }) => {
  Vue.directive('hide', function (el, binding) {
    el.style.visibility = !binding.value ? 'visible' : 'hidden';
  });
});
